import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../../apiBase';
import '../../pages/admin/sms-management.css';

export default function SmsBalanceSection({ schoolId, api }) {
    const { t } = useTranslation(['sms', 'common']);
    const [data, setData] = useState(null);
    const [history, setHistory] = useState([]);
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState('');

    const client = api || axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });

    useEffect(() => {
        if (!schoolId) return;
        load();
    }, [schoolId]);

    async function load() {
        try {
            const [balRes, histRes] = await Promise.all([
                client.get('/school/sms/balance', { params: { schoolId } }),
                client.get('/school/sms/history', { params: { schoolId, pageSize: 10 } })
            ]);
            setData(balRes.data);
            setHistory(histRes.data || []);
        } catch {
            setData(null);
        }
    }

    async function purchase(count) {
        setBusy(true);
        setMsg('');
        try {
            const res = await client.post('/school/sms/purchase', { packageSize: count }, { params: { schoolId } });
            if (res.data?.paymentUrl) {
                window.location.href = res.data.paymentUrl;
            }
        } catch (e) {
            setMsg(e.response?.data?.message || t('common:error'));
        } finally {
            setBusy(false);
        }
    }

    if (!data) return null;

    const tariff = data.tariff;
    const packages = tariff?.packages || [];

    return (
        <div>
            <div className="sms-balance-card">
                <div className="sms-balance-number">
                    {data.smsBalance}
                    <span>SMS</span>
                </div>
                {data.smsBalance <= (data.lowBalanceThreshold ?? 10) && (
                    <div className="sms-low-warning">⚠️ {t('sms:lowBalance')}</div>
                )}
                {data.isBlocked && (
                    <div className="sms-blocked-warning">
                        🔴 {t('sms:blocked')}: {data.blockReason}
                    </div>
                )}
            </div>

            {tariff && (
                <>
                    <h3 style={{ margin: '0 0 12px' }}>{t('sms:packages')}</h3>
                    <div className="sms-packages">
                        {packages.map((pkg) => (
                            <div
                                key={pkg.count}
                                className="sms-package-card"
                                onClick={() => !busy && purchase(pkg.count)}
                                role="button"
                                tabIndex={0}
                            >
                                <div className="sms-package-count">{pkg.count} SMS</div>
                                <div className="sms-package-price">
                                    {pkg.price} {tariff.currency}
                                </div>
                                <div className="sms-package-unit">
                                    {(pkg.pricePerSms ?? 0).toFixed(2)} {t('sms:pricePerSms')}
                                </div>
                                {pkg.count >= 1000 && (
                                    <div style={{ fontSize: 11, color: '#16a34a', marginTop: 6 }}>Выгодно!</div>
                                )}
                            </div>
                        ))}
                    </div>
                </>
            )}

            {msg ? <p style={{ color: '#b91c1c' }}>{msg}</p> : null}

            {history.length > 0 && (
                <>
                    <h3 style={{ margin: '16px 0 8px' }}>{t('sms:history')}</h3>
                    <table className="sms-mgmt-table">
                        <thead>
                            <tr>
                                <th>Тип</th>
                                <th>SMS</th>
                                <th>Баланс</th>
                                <th>Дата</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map((row) => (
                                <tr key={row.id}>
                                    <td>{row.type}</td>
                                    <td>{row.smsAmount}</td>
                                    <td>{row.balanceAfter}</td>
                                    <td>{new Date(row.createdAt).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
}
